import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class OutputService {

  constructor(
    private http: MiraieService,
  ) { }

  //週報出力
  weeklyReport(weeklyReport, result, target){
    var url = "output-wr";
    let param = { weeklyReport, result, target };
    return this.http.post(url, param, {responseType: 'blob'});
  }

  //契約進捗一覧
  contract( year ,quarter ,division_name ,quarter_alllist ,quarter_list ,result_list ,user_list ){
    var url = "output-ctct";
    let param = { year ,quarter ,division_name ,quarter_alllist ,quarter_list ,result_list ,user_list };
    return this.http.post(url, param, {responseType: 'blob'});
  }

  //予実
  goal( date , view , divilist ){
    var url = "output-gl";
    let param = { date , view , divilist };
    return this.http.post(url, param, {responseType: 'blob'});
  }

  //失注原因
  lost( date , result_list ){
    var url = "output-lst";
    let param = { date , result_list };
    return this.http.post(url, param, {responseType: 'blob'});
  }

  //週報出力
  summary(span ,start_date ,end_date ,summary_list ,now_summary ){
    var url = "output-smr";
    let param = { span ,start_date ,end_date ,summary_list ,now_summary  };
    return this.http.post(url, param, {responseType: 'blob'});
    //return this.http.post(url, param);
  }

  //工程表
  proccess( result_list ){
    var url = "output-process";
    let param = { 'list': result_list };
    return this.http.post(url, param, {responseType: 'blob'});
  }
  
  //面談集計出力
  getInterviewList(year, month) {
    var url = "output-interview";
    let param = { year, month }

    return this.http.post(url, param, {responseType: 'blob'});
  }
}
